/* ==========================================================================
   GALERIE — comportements du thème
   Vanilla JS, aucune dépendance. Tout dégrade proprement sans JavaScript.
   ========================================================================== */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  /* ------------------------------------------------------------------------
     Apparitions au défilement
     ---------------------------------------------------------------------- */
  function initReveal(scope) {
    var targets = $$('[data-reveal]:not(.is-in)', scope);
    if (!targets.length) return;

    if (reduced || !('IntersectionObserver' in window) || document.documentElement.classList.contains('no-anim')) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    targets.forEach(function (el) { io.observe(el); });
  }

  /* ------------------------------------------------------------------------
     Menu mobile
     ---------------------------------------------------------------------- */
  function initMobileNav() {
    var panel = $('[data-mobile-nav]');
    if (!panel) return;
    var openers = $$('[data-nav-open]');
    var closers = $$('[data-nav-close]', panel);

    function setOpen(open) {
      panel.dataset.open = open ? 'true' : 'false';
      document.body.dataset.navOpen = open ? 'true' : 'false';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) {
        var first = $('a, button', panel);
        if (first) first.focus();
      }
    }

    openers.forEach(function (b) { on(b, 'click', function () { setOpen(panel.dataset.open !== 'true'); }); });
    closers.forEach(function (b) { on(b, 'click', function () { setOpen(false); }); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape' && panel.dataset.open === 'true') setOpen(false); });
    $$('a', panel).forEach(function (a) { on(a, 'click', function () { setOpen(false); }); });
  }

  /* ------------------------------------------------------------------------
     Accordéons
     ---------------------------------------------------------------------- */
  function initAccordions(scope) {
    $$('[data-accordion]', scope).forEach(function (group) {
      if (group.dataset.bound === 'true') return;
      group.dataset.bound = 'true';
      var single = group.dataset.accordion === 'single';

      $$('.accordion__head', group).forEach(function (head) {
        on(head, 'click', function () {
          var item = head.closest('.accordion__item');
          var open = item.dataset.open === 'true';

          if (single && !open) {
            $$('.accordion__item', group).forEach(function (other) {
              other.dataset.open = 'false';
              var h = $('.accordion__head', other);
              if (h) h.setAttribute('aria-expanded', 'false');
            });
          }
          item.dataset.open = open ? 'false' : 'true';
          head.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
    });
  }

  /* ------------------------------------------------------------------------
     Bandeau défilant : on duplique le contenu pour une boucle sans couture
     ---------------------------------------------------------------------- */
  function initMarquee(scope) {
    $$('[data-marquee]', scope).forEach(function (el) {
      var track = $('.marquee__track', el);
      if (!track || track.dataset.bound === 'true') return;
      track.dataset.bound = 'true';

      var item = $('.marquee__item', track);
      if (!item) return;

      var needed = Math.ceil((window.innerWidth * 2) / Math.max(item.offsetWidth, 1)) + 1;
      for (var i = 1; i < needed; i++) track.appendChild(item.cloneNode(true));

      // La moitié du contenu défile, l'autre prend le relais : boucle infinie.
      var half = track.children.length;
      for (var j = 0; j < half; j++) track.appendChild(track.children[j].cloneNode(true));
    });
  }

  /* ------------------------------------------------------------------------
     Sélecteurs de quantité
     ---------------------------------------------------------------------- */
  function initQuantity(scope) {
    $$('[data-qty]', scope).forEach(function (widget) {
      if (widget.dataset.bound === 'true') return;
      widget.dataset.bound = 'true';
      var input = $('input', widget);

      $$('button', widget).forEach(function (btn) {
        on(btn, 'click', function () {
          var step = btn.dataset.qtyStep === 'up' ? 1 : -1;
          var min = parseInt(input.min || '1', 10);
          var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
          if (String(next) === input.value) return;
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ------------------------------------------------------------------------
     Panier : tiroir latéral + ajouts en arrière-plan
     ---------------------------------------------------------------------- */
  var Cart = {
    drawer: null,
    overlay: null,
    lastFocus: null,

    refs: function () {
      this.drawer = $('[data-cart-drawer]');
      this.overlay = $('[data-cart-overlay]');
    },

    open: function () {
      this.refs();
      if (!this.drawer) return;
      this.lastFocus = document.activeElement;
      this.drawer.dataset.open = 'true';
      if (this.overlay) this.overlay.dataset.open = 'true';
      document.body.dataset.navOpen = 'true';
      var close = $('[data-cart-close]', this.drawer);
      if (close) close.focus();
    },

    close: function () {
      this.refs();
      if (!this.drawer) return;
      this.drawer.dataset.open = 'false';
      if (this.overlay) this.overlay.dataset.open = 'false';
      document.body.dataset.navOpen = 'false';
      if (this.lastFocus) this.lastFocus.focus();
    },

    /* Recharge le HTML du tiroir via l'API de rendu de sections de Shopify */
    refresh: function () {
      return fetch(root + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data['cart-drawer'];
          if (!html) return;
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-cart-drawer]', parsed);
          var current = $('[data-cart-drawer]');
          if (fresh && current) {
            current.innerHTML = fresh.innerHTML;
            Cart.bindDrawer();
            initQuantity(current);
          }
          var count = parsed.querySelector('[data-cart-count-value]');
          if (count) Cart.setCount(count.textContent.trim());
        })
        .catch(function () { window.location.href = root + 'cart'; });
    },

    setCount: function (value) {
      var n = parseInt(value, 10) || 0;
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.hidden = n === 0;
      });
    },

    add: function (form, button) {
      var body = new FormData(form);
      var original = button ? button.innerHTML : '';
      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.innerHTML = button.dataset.loadingText || 'Ajout…';
      }

      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: body
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.data && res.data.description) || 'Erreur');
          return Cart.refresh().then(function () { Cart.open(); });
        })
        .catch(function (err) {
          var slot = form.querySelector('[data-form-error]');
          if (slot) {
            slot.textContent = err.message;
            slot.hidden = false;
          } else {
            form.submit();
          }
        })
        .then(function () {
          if (button) {
            button.removeAttribute('aria-disabled');
            button.innerHTML = original;
          }
        });
    },

    change: function (line, quantity) {
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function () { return Cart.refresh(); });
    },

    bindDrawer: function () {
      Cart.refs();
      if (!Cart.drawer) return;

      $$('[data-cart-close]', Cart.drawer).forEach(function (b) { on(b, 'click', function () { Cart.close(); }); });

      $$('[data-line-remove]', Cart.drawer).forEach(function (b) {
        on(b, 'click', function (e) {
          e.preventDefault();
          Cart.change(parseInt(b.dataset.lineRemove, 10), 0);
        });
      });

      $$('[data-line-qty]', Cart.drawer).forEach(function (input) {
        on(input, 'change', function () {
          Cart.change(parseInt(input.dataset.lineQty, 10), parseInt(input.value, 10) || 0);
        });
      });
    },

    init: function () {
      Cart.refs();
      Cart.bindDrawer();

      $$('[data-cart-open]').forEach(function (b) {
        on(b, 'click', function (e) {
          if (document.documentElement.dataset.cartType !== 'drawer') return;
          e.preventDefault();
          Cart.refresh().then(function () { Cart.open(); });
        });
      });

      if (Cart.overlay) on(Cart.overlay, 'click', function () { Cart.close(); });
      on(document, 'keydown', function (e) {
        if (e.key === 'Escape' && Cart.drawer && Cart.drawer.dataset.open === 'true') Cart.close();
      });

      $$('[data-product-form]').forEach(function (form) {
        on(form, 'submit', function (e) {
          if (document.documentElement.dataset.cartType !== 'drawer') return;
          e.preventDefault();
          Cart.add(form, $('[data-add-button]', form));
        });
      });
    }
  };

  /* ------------------------------------------------------------------------
     Page produit : variantes et galerie
     ---------------------------------------------------------------------- */
  function initProduct(scope) {
    $$('[data-product]', scope).forEach(function (el) {
      if (el.dataset.bound === 'true') return;
      el.dataset.bound = 'true';

      var dataEl = $('[data-variants]', el);
      if (!dataEl) return;

      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      var idInput = $('[data-variant-id]', el);
      var priceSlot = $('[data-price]', el);
      var compareSlot = $('[data-price-compare]', el);
      var addBtn = $('[data-add-button]', el);
      var stockSlot = $('[data-stock]', el);
      var radios = $$('[data-option-input]', el);

      function currentOptions() {
        var byIndex = {};
        radios.forEach(function (r) { if (r.checked) byIndex[r.dataset.optionIndex] = r.value; });
        return byIndex;
      }

      function matchVariant() {
        var opts = currentOptions();
        return variants.filter(function (v) {
          return v.options.every(function (value, i) { return opts[i] === undefined || opts[i] === value; });
        })[0];
      }

      function apply() {
        var v = matchVariant();
        if (!v) return;

        if (idInput) idInput.value = v.id;
        if (priceSlot) priceSlot.innerHTML = v.price;
        if (compareSlot) {
          compareSlot.innerHTML = v.compare_at || '';
          compareSlot.hidden = !v.compare_at;
        }
        if (stockSlot) {
          stockSlot.classList.toggle('stock--out', !v.available);
          var text = $('[data-stock-text]', stockSlot);
          if (text) text.textContent = v.available ? stockSlot.dataset.inText : stockSlot.dataset.outText;
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          var lbl = $('[data-add-label]', addBtn);
          if (lbl) lbl.textContent = v.available ? addBtn.dataset.addText : addBtn.dataset.soldText;
        }

        if (v.media_index !== null && v.media_index !== undefined) selectMedia(v.media_index);

        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
      }

      function selectMedia(index) {
        var thumbs = $$('[data-thumb]', el);
        var slides = $$('[data-slide]', el);
        if (!slides.length) return;
        slides.forEach(function (s) { s.hidden = parseInt(s.dataset.slide, 10) !== index; });
        thumbs.forEach(function (t) {
          t.setAttribute('aria-current', parseInt(t.dataset.thumb, 10) === index ? 'true' : 'false');
        });
      }

      radios.forEach(function (r) { on(r, 'change', apply); });
      $$('[data-thumb]', el).forEach(function (t) {
        on(t, 'click', function () { selectMedia(parseInt(t.dataset.thumb, 10)); });
      });
    });
  }

  /* ------------------------------------------------------------------------
     Page panier : mise à jour à la volée
     ---------------------------------------------------------------------- */
  function initCartPage(scope) {
    var form = $('[data-cart-form]', scope);
    if (!form || form.dataset.bound === 'true') return;
    form.dataset.bound = 'true';

    $$('[data-cart-line-qty]', form).forEach(function (input) {
      on(input, 'change', function () { form.submit(); });
    });
  }

  /* ------------------------------------------------------------------------
     En-tête : état compact au défilement
     ---------------------------------------------------------------------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var last = 0;
    function update() {
      var y = window.scrollY;
      header.dataset.scrolled = y > 12 ? 'true' : 'false';
      last = y;
    }
    update();
    window.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
  }

  /* ------------------------------------------------------------------------
     Amorçage
     ---------------------------------------------------------------------- */
  function boot(scope) {
    initReveal(scope);
    initAccordions(scope);
    initMarquee(scope);
    initQuantity(scope);
    initProduct(scope);
    initCartPage(scope);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    boot(document);
    initMobileNav();
    initHeader();
    Cart.init();
  });

  /* Re-amorçage après un rendu de section dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
    Cart.init();
  });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });

  window.Galerie = { boot: boot, cart: Cart };
})();
